import {
  Div,
  Group,
  Panel,
  PanelHeader,
  PanelHeaderBack
} from '@vkontakte/vkui';
import { useUnit } from 'effector-react';
import { memo, useCallback } from 'react';
import {
  AppPanels,
  AppPanelsT
} from 'src/app/providers/RouteProvider/lib/routeConfig';
import { setActivePanel } from 'src/entity/ActivePanel';
import { Cover } from 'src/shared/ui/cover';
import styles from './styles.module.scss';

interface IRulesPanel {
  id: AppPanelsT;
}

export const RulesPanel = memo(({ id }: IRulesPanel) => {
  const [onSetActivePanel] = useUnit([setActivePanel]);

  const onBackClickHandler = useCallback(() => {
    onSetActivePanel(AppPanels.INTRO);
  }, [onSetActivePanel]);

  return (
    <Panel id={id}>
      <PanelHeader
        separator={false}
        style={{ width: '0px' }}
        before={(
          <PanelHeaderBack
            onClick={onBackClickHandler}
          />
        )}
        className={styles.rules__header}
      />
      <Div className={styles.rules__container}>
        <Group aria-setsize={100} className={styles.rules__text}>
          <Div>
            <p style={{ textAlign: 'center' }}>
              Акционерное общество «Карусель» (АО «Карусель»)
            </p>

            <p style={{ margin: '15px 0; text', textAlign: 'right' }}>
              Утверждены
              <br />
              {' '}
              Приказом Директоров
              <br />
              {' '}
              АО «Карусель»
            </p>

            <h1>
              Правила проведения Национальной детской премии «Главные Герои
              2023»
            </h1>
          </Div>
          <Div>
            <br />
            <b>1. Общие положения</b>
            <br />
            1.1. Настоящие Правила определяют порядок проведения Национальной
            детской премии «Главные Герои» (далее — «Премия»).
            <br />
            <br />
            1.2. Организатором Премии выступает АО «Карусель» (ОГРН
            5107746038340, ИНН 7717689933, адрес: 127427, Российская Федерация,
            г. Москва, Академика Королева, 19, пом. 5045 далее — Организатор).
            <br />
            <br />
            1.3. Премия проводится на территории Российской Федерации в
            соответствии с настоящими Правилами, а также действующим
            законодательством РФ.
            <br />
            <br />
            1.4. Информирование о Правилах проведения Премии осуществляется
            путем размещения информации на Интернет-сайте телеканала «Карусель»
            - https://www.karusel-tv.ru/glavgeroi2023 (далее — «Сайт»).
            Организатор оставляет за собой право изменять настоящие Правила в
            одностороннем порядке. Все изменения, вносимые в Правила проведения
            Премии, размещаются на указанном сайте.
            <br />
            <br />
            1.5. Участие в премии означает согласие номинанта с данными
            Правилами.
            <br />
            <br />
            <b>2. Правила голосования в Премии</b>
            <br />
            <br />
            2.1. Премия вручается в 12 номинациях:
            <br />
            1. Главный познавательный ТВ-проект
            <br />
            2. Главный развлекательный ТВ-проект
            <br />
            3. Главная ведущая ТВ-программы
            <br />
            4. Главный ведущий ТВ-программы
            <br />
            5. Главный юный ведущий
            <br />
            6. Главная детская песня
            <br />
            7. Главный анимационный фильм
            <br />
            8. Главный познавательный анимационный сериал
            <br />
            9. Главный комедийный анимационный сериал
            <br />
            10. Главный развивающий анимационный сериал
            <br />
            11. Главная премьера анимационного сериала
            <br />
            12. Главный анимационный герой
            <br />
            <br />
            2.1.1. Для целей настоящих Правил номинантами в номинациях 1-2, 6-12
            считаются правообладатели соответствующих аудиовизуальных
            произведений, номинантами в номинациях 3,4,5 — указанные в названиях
            номинаций физические лица
            <br />
            <br />
            2.1.2. Организатор имеет право изменять номинации и перечень
            номинантов по своему усмотрению.
            <br />
            <br />
            2.2. Организатор Премии формирует экспертную комиссию, которая в
            период с 1 июля по 1 августа 2023 года года осуществляет отбор
            номинантов перед началом голосования. При отборе номинантов комиссия
            может использовать предложения Пользователей, оставленные через
            специальную форму на Сайте Организатора и на странице телеканала в
            социальной сети «ВКонтакте». Результаты оформляются протоколом,
            подписываемым всеми участниками комиссии. Количество номинантов,
            выбранных комиссией, составляет не менее 3 (трёх) в каждой
            номинации.
            <br />
            <br />
            2.2.1. Организатор премии информирует номинантов об их выдвижении
            путем направления соответствующего уведомления в письменном виде или
            с использованием средств электронной связи.
            <br />
            <br />
            2.2.2. Номинант вправе отказаться от участия в Премии путем
            уведомления об этом Организатора любым доступным ему способом.
            <br />
            <br />
            2.3. После того, как комиссия отобрала номинантов, полный список
            номинантов обнародуется к началу on-line голосования на странице
            Премии на сайте телеканала «Карусель»
            https://www.karusel-tv.ru/glavgeroi2023 и на странице Телеканала в
            социальной сети «ВКонтакте» https://vk.com/tvkarusel, где и будет
            проводиться открытое on-line голосование. Период проведения
            открытого on-line голосования с 00:01 по московскому времени «01»
            августа 2023 г. по 15:00 по московскому времени «26» октября 2023 г.
            <br />
            <br />
            2.4. В голосовании могут принять участие дети от 6 до 18 лет. Каждый
            участник голосования может проголосовать неограниченное количество
            раз в каждой номинации за всё время проведения голосования.
            <br />
            <br />
            2.5. Подсчет результатов голосования осуществляется автоматически и
            оформляется протоколом Счетной комиссии, сформированной
            Организатором ко дню закрытия голосования. On-line голосование
            считается легитимным при любом количестве участников голосования.
            <br />
            <br />
            В Протоколе результатов голосования указывается:
            <br />
            • наименование документа, дата и время фиксации результатов
            голосования, количество его страниц, указание номинации;
            <br />
            • число проголосовавших (отдельно — по каждой номинации);
            <br />
            • фамилии и инициалы членов Счетной комиссии;
            <br />
            <br />
            Протокол заверяется подписями членов Счетной комиссии.
            <br />
            Протокол о результатах голосования хранится Организатором в течение
            одного года со дня проведения церемонии награждения победителей
            Премии.
            <br />
            <br />
            2.6. Организатор сохраняет за собой право частично аннулировать
            голоса, поданные за отдельных номинантов, по своему усмотрению, в
            том числе в случае, если Организатором будут выявлены факты
            использования технических средств массового голосования.
            <br />
            <br />
            <b>3. Правила определения победителей Премии</b>
            <br />
            3.1. По итогам on-line голосования определяются 3 (три) финалиста в
            каждой номинации, набравшие большее количество голосов, и информация
            о них размещается на Сайте. Победителем признается один из трех
            финалистов, набравший большее число голосов в ходе on-line
            голосования.
            <br />
            <br />
            3.2. По результатам проведения on-line голосования Счетная комиссия
            определяет Победителя в каждой номинации.
            <br />
            <br />
            3.3. Победитель в каждой номинации, набравший наибольшее количество
            голосов, будет объявлен путем размещения информации 2 ноября 2023
            года на странице Премии на сайте телеканала «Карусель»
            https://www.karusel-tv.ru/glavgeroi2023 и на странице Телеканала в
            социальной сети «ВКонтакте» https://vk.com/tvkarusel.
            <br />
            <br />
            3.4. Каждый победитель получает приз — статуэтку «Главные герои».
            <br />
            Организатор может по собственному усмотрению изменить наименование
            приза.
            <br />
            <br />
            <b>
              4. Особые условия участия в премии для номинантов и
              правообладателей
            </b>
            <br />
            <br />
            4.1. Номинанты Премии предоставляют (а в случае
            номинантов-физических лиц подтверждают согласие правообладателя на
            предоставление) неисключительное право (лицензию) на фрагментарное
            использование без выплаты вознаграждения аудиовизуального
            произведения, номинированного на Премию, в том числе изображений
            (стоп-кадров, фотографий и т.д.), фрагментов и/или промо-материалов
            указанного произведения (трейлер, клип, фрагмент аудио-визуального
            произведения), следующими способами:
            <br />
            Неисключительное право на использование материалов на Сайте и
            странице Премии, а также в социальных сетях телеканала и Премии (VK,
            Одноклассники), во время Премии.
            <br />
            <br />
            Неисключительное право на использование материалов, фрагментарное
            использование без выплаты вознаграждения аудиовизуального
            произведения, номинированного на Премию, в том числе изображений
            (стоп-кадров, фотографий и т.д.), фрагментов и/или промо-материалов
            указанного произведения (трейлер, клип, фрагмент аудио-визуального
            произведения) в составе Телеканала во время трансляции в эфире,
            через спутник, сообщение для всеобщего сведения по радио или
            телевидению с помощью кабеля, провода, оптического волокна или
            аналогичных средств (в том числе путем ретрансляции).
            <br />
            Неисключительное право использовать материалы продолжительностью не
            более 3 (трех минут) при рекламировании, промотировании и
            анонсировании Премии. Объявлении результатов Премии.
            <br />
            <br />
            4.2. Победители Премии предоставляют (а в случае
            номинантов-физических лиц подтверждают согласие правообладателя на
            предоставление) неисключительное право (лицензию) на фрагментарное
            использование без выплаты вознаграждения аудиовизуального
            произведения, победителя Премии, в том числе изображений
            (стоп-кадров, фотографий и т.д.), фрагментов и/или промо-материалов
            указанного произведения (трейлер, клип, фрагмент аудио-визуального
            произведения, неисключительное право использовать материалы
            продолжительностью не более 3 (трех минут), следующими способами:
            <br />
            Неисключительное право на использование материалов на Сайте и
            странице Премии, а также в социальных сетях телеканала и Премии (VK,
            Одноклассники), после объявления результатов Премии и в течении
            неограниченного количества времени;
            <br />
            Неисключительное право на использование материалов, фрагментарное
            использование без выплаты вознаграждения аудиовизуального
            произведения, победителя Премии, в том числе изображений
            (стоп-кадров, фотографий и т.д.), фрагментов и/или промо-материалов
            указанного произведения (трейлер, клип, фрагмент аудио-визуального
            произведения) в составе Телеканала во время трансляции в эфире,
            через спутник, сообщение для всеобщего сведения по радио или
            телевидению с помощью кабеля, провода, оптического волокна или
            аналогичных средств (в том числе путем ретрансляции).
            <br />
            <br />
            4.3. Предоставление Организатору материалов не нарушает права
            третьих лиц и соответствует действующему законодательству РФ. В
            случае предъявления к Организатору требований и/или претензий со
            стороны третьих лиц, связанных с содержанием материалов, лицо,
            предоставившее такие материалы, обязуется содействовать
            урегулированию таких претензий и/или требований. Настоящее
            разрешение допускает использование материалов без указания имени
            автора и имени/названия правообладателя в ходе церемонии
            награждения.
            <br />
            <br />
            4.4. Победители Премии, принявшие участие в церемонии награждения,
            предоставляют Организатору право на фото-видеосъемку, а также на
            последующее использование изображения Организатором без ограничения
            сроков и территории использования и выплаты какого-либо
            вознаграждения.
          </Div>
        </Group>
      </Div>
      <Cover />
    </Panel>
  );
});
